import React from "react";

const Mail = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-8 h-8 text-red-500"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2v.01L12 11 4 6h16zM4 18V8l8 5 8-5v10H4z" />
      </svg>
    </div>
  );
};

export default Mail;
